<template>
<div id="map">

</div>



</template>

<script>
import Mapbox from 'mapbox-gl-vue'

export default {
  name: 'Mapbox',
  props: {
      allPropertyData: Array,
      filteredData: Array,
      address: String,
      neighborhood: String,
      parcelNum: String,
      propertyType: String,


  },
  data() {
      return {
        accessToken: "pk.eyJ1Ijoiam1vbGxtYW4iLCJhIjoiY2tlZWo5bXR6MDB0ODJ5cXRmMGF3Z292dyJ9.1p8JgVqMKvSMjdVnJLuALw",
        map: '',
        markers: [],

      }
  },
  watch: {
    filteredData() {
     this.map.setFilter('locations', ['match', ['get', 'ppn'], this.filteredData.map(function(feature) {
            return feature.ppn;
        }), true, false]);
    },
    filteredGeoJSON: () => {
      console.log(this.filteredGeoJSON);
    }
  },
  computed: {
    filteredGeoJSON() {

      return this.filteredData.map((item) => {
        let newItem = {};
        newItem['type'] = 'Feature';
        newItem['properties'] = {
          "ppn" : item.ppn,
          "address" : item.parcel_address,
          "neighborhood" : item.neighborhood,
          "price" : this.$parent.formatPrice(item.suggested_listing_price),
          "hclrc_prop_type" : item.hclrc_prop_type,
          "image" : item.main_pic_link,
        };
        newItem['geometry']= {
          "type" : "Point",
          "coordinates" : [
            item.longitude, item.latitude
          ]
        };
        return newItem;

      }) || []; // return either filteredData array or an empty array

    },
  },
  mounted() {
      this.createMap();
  },
  methods: {
    createMap() {
      mapboxgl.accessToken = this.accessToken;
      // init the map
      var map = new mapboxgl.Map({
        // ID of container 
        container: 'map',
        // Style URL
        style: 'mapbox://styles/mapbox/streets-v11',
        // Center of the map
        center: [-84.3814, 39.1601],
        zoom: 10,
      });

      // Don't allow zoom on scorll
      map.scrollZoom.disable();

      // Add navigation to the top left corner
      var nav = new mapboxgl.NavigationControl();
			map.addControl(nav, 'top-left');

      this.$set(this, 'map', map);

      // Once map has loaded...
      this.map.on('load', function(e) {
            // Add layer to the map
            this.map.addLayer({
              "id": 'locations',
              "type": 'circle',
              // Add a GeoJSON source containing place coordinates and information.
              "source": {
                "type": 'geojson',
                "data": {
                  "type": "FeatureCollection",
                  "features": this.filteredGeoJSON
                }
              },
              // Add icon marker from Mapbox 
              'paint': {
                  // make circles larger as the user zooms from z12 to z22
                  'circle-radius': {
                      'base': 2.75,
                      'stops': [[12, 4], [20, 180]]
                  },
                  // color circles by property type, using a match expression
                  // https://www.mapbox.com/mapbox-gl-js/style-spec/#expressions-match
                  'circle-color': [
                      'match', ['get', 'hclrc_prop_type'],
                      'Residential Land', '#fdbb48',
                      'Residential Building', '#fdbb48',
                      'Commercial Land', '#e53d51',
                      'Commercial Building', '#e53d51',
                      'Industrial Land', '#533278',
                      /* default */ '#000000',
                  ]
              }
              
              
            });
      }.bind(this));

      this.map.on('click', function(e) {
        // Get the information under the mouse
        var clickedProperties = this.map.queryRenderedFeatures(e.point, { layers: ['locations'] });

        var clickedPoint = clickedProperties[0];

        // Remove any currently open popups 
        this.removeAllPopUps();

        // Fly to the point
        this.flyToPoint(clickedPoint);

        // When the fly animation ends, display the popup
        this.map.once('moveend', function(e) {
          this.createPopUp(clickedPoint);
        }.bind(this))
      }.bind(this));
    },
    createPopUp(clickedPoint) {
      var imageLink;
      if (clickedPoint.properties.image) {
        imageLink = clickedPoint.properties.image;
      } else {
        imageLink = "/assets/images/default house image@2x.png"
      }
      var popup = new mapboxgl.Popup({ closeOnClick: false })
        .setLngLat(clickedPoint.geometry.coordinates)
        .setHTML(`<div class="popup-image" style="background-image:url('${ imageLink }');"></div>
        <p class="address ${clickedPoint.properties.hclrc_prop_type}">${ clickedPoint.properties.address }</p>
        <p class="price"><strong>Price: </strong>$${ clickedPoint.properties.price }</p>
        <p class="neighborhood"><strong>Neighborhood: </strong>${ clickedPoint.properties.neighborhood }</p>
        <a href="/available-properties/${ clickedPoint.properties.ppn }/">Learn More</a>`)
        .addTo(this.map);
    },
    flyToPoint(clickedPoint) {
        this.map.flyTo({
          center: clickedPoint.geometry.coordinates,
          zoom: 15,
          speed: 1.3,
        });
      },
        
    removeAllPopUps() {
      var popUps = document.getElementsByClassName('mapboxgl-popup');
			if ( popUps.length ) popUps[0].remove();
    }
  },
    
}
</script>


<style lang="scss">
.mapboxgl-popup {
  transform: none !important;
  left: 50%;
  height: 100%;
  flex-direction: row;
}
.mapboxgl-popup-tip {
    border-right-color: #fff;
    border-top: 10px solid transparent !important;
    border-bottom-color: transparent !important;
}
#map {
  .mapboxgl-canvas-container {
    .mapboxgl-canvas {
      position: relative !important;
    }
  }
}
.mapboxgl-popup-content {
  width: 300px;
  height: fit-content;
  align-self: center;
  text-align: left;

  .mapboxgl-popup-close-button {
    font-size: 1.5rem;

    &:hover {
      background-color: transparent;
    }
  }

  p {
    font-size: .875rem;
    margin-bottom: 0;
  }
  .popup-image {
    margin-top: 1.5rem;
    min-height: 150px;
    background-size: cover;
    background-position: top;
  }

  p.address {
    font-family: 'din-2014';
    font-weight: 700;
    font-size: 1rem;
    margin-top: .5rem;
    line-height: 24px;

  }
  p.price {
    font-family: "neue-haas-unica";
    font-weight: 500;
    margin-bottom: 0;
  }
  p.neighborhood {
    font-family: "neue-haas-unica";
    font-weight: 500;
  }

  a {
    font-size: 1rem;
    color: #dc3b43;
    font-family: 'din-2014';
    font-weight: 600;

    &:hover {
      text-decoration: underline;
    }

  }

  

  
}

</style>


// WEBPACK FOOTER //
// src/components/Mapbox.vue